import {
    categoryLinkSchema,
    imageItemSchema,
    priceItemSchema,
    selectionListLinkSchema,
} from '@coas/validators/payload';
import { z } from 'zod';
import { genderSchema } from '../const/genderSchema';
import { productArticleSchema } from '../const/producArticleSchema';
import { sellerPlatformSchema } from '../const/sellerPlatformSchema';
import { slugBaseSchema } from '../const/slugBaseSchema';
import { uuidSchema } from '../const/uuidSchema';

export const productStageDraftInputSchema = z.object({
    id: uuidSchema.optional(),

    name: z.string().trim().max(300).optional(),
    gender: genderSchema.optional(),

    baseSlug: slugBaseSchema.optional(),
    article: productArticleSchema.nullable().optional(),

    sellerPlatform: sellerPlatformSchema.optional().nullable(),
    poizonSpuId: z.string().trim().max(120).optional().nullable(),

    tags: z.array(z.string().trim().max(50)).optional(),

    hasPersonOnFirstImage: z.boolean().optional(),
    bookmark: z.boolean().optional(),

    description: z.string().trim().max(20000).optional().nullable(),
    imageForInternalUser: z.string().trim().optional().nullable(),
    imageForInternalUserNote: z.string().trim().optional().nullable(),

    images: z.array(imageItemSchema).optional(),
    categories: z.array(categoryLinkSchema).optional(),
    selectionLists: z.array(selectionListLinkSchema).optional(),

    brands: z.array(uuidSchema).optional(),
    colors: z.array(uuidSchema).optional(),

    sizeChartId: uuidSchema.optional().nullable(),
    prices: z.array(priceItemSchema).optional(),
});

export type ProductStageDraftInputSchema = z.infer<typeof productStageDraftInputSchema>;
